<script>
import { mapActions } from 'vuex';

export default {
  name: 'ReviewEditContainer',
  props: {
    name: {
      type: Object,
      default: () => {},
    },
    title: {
      type: Object,
      default: () => {},
    },
    description: {
      type: Object,
      default: () => {},
    },
    pros: {
      type: Array,
      default: () => [],
    },
    cons: {
      type: Array,
      default: () => [],
    },
    reviewId: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      editReviewDialog: false,
      confirmationDialog: false,
      nameText: this.name ? this.name.text : '',
      titleText: this.title ? this.title.text : '',
      descriptionText: this.description ? this.description.text : '',
      prosText: this.pros,
      consText: this.cons,
      customerNameLabel: this.$t('review.reviewEditContainer.customerName'),
      titleLabel: this.$t('review.reviewEditContainer.title'),
      descriptionLabel: this.$t('review.reviewEditContainer.description'),
      proLabel: this.$t('review.reviewEditContainer.pro'),
      conLabel: this.$t('review.reviewEditContainer.con'),
    };
  },
  methods: {
    ...mapActions({
      updateReviewInformationText: 'review/updateReviewInformationText',
    }),
    updateReviewInformation() {
      const reviewInformation = [
        {
          reviewId: this.reviewId,
        },
      ];
      if (this.name && this.name.text !== this.nameText) {
        reviewInformation.push(
          {
            reviewInformationId: this.name.id,
            reviewInformationText: this.nameText,
          },
        );
      }
      if (this.title && this.title.text !== this.titleText) {
        reviewInformation.push(
          {
            reviewInformationId: this.title.id,
            reviewInformationText: this.titleText,
          },
        );
      }
      if (this.description && this.description.text !== this.descriptionText) {
        reviewInformation.push(
          {
            reviewInformationId: this.description.id,
            reviewInformationText: this.descriptionText,
          },
        );
      }
      if (this.pros.length) {
        this.prosText.forEach((pro) => {
          reviewInformation.push(
            {
              reviewInformationId: pro.id,
              reviewInformationText: pro.text,
            },
          );
        });
      }
      if (this.cons.length) {
        this.consText.forEach((con) => {
          reviewInformation.push(
            {
              reviewInformationId: con.id,
              reviewInformationText: con.text,
            },
          );
        });
      }
      this.updateReviewInformationText(reviewInformation);
      this.editReviewDialog = false;
      this.confirmationDialog = false;
    },
  },
};
</script>

<template>
  <v-layout row justify-center>
    <v-dialog v-model="editReviewDialog" persistent max-width="1000px">
      <template v-slot:activator="{ on }">
        <v-btn
          :disabled="!name && !title && !description && !pros.length && !cons.length"
          xsmall color="primary"
          v-on="on"
          flat
        >
          {{ $t("review.reviewEditContainer.edit") }}
          <v-icon>edit</v-icon>
        </v-btn>
      </template>
      <v-card>
        <v-card-title>
          <span class="mx-4 headline">{{ $t("review.reviewEditContainer.editReview")}}</span>
        </v-card-title>
        <v-card-text>
          <v-container grid-list-md>
            <v-text-field
              v-if="name"
              v-model="nameText"
              :label="customerNameLabel"
              required
            >
            </v-text-field>
            <v-textarea rows="1"
              v-if="title"
              v-model="titleText"
              :label="titleLabel"
              auto-grow
            ></v-textarea>
            <v-textarea
              v-if="description"
              v-model="descriptionText"
              :label="descriptionLabel"
              auto-grow
              box
              counter
            ></v-textarea>
            <v-layout>
              <v-flex>
                <v-textarea rows="1"
                  v-if="prosText.length"
                  v-for="pro in prosText"
                  v-model="pro.text"
                  :key="pro.id"
                  :label="proLabel"
                  auto-grow
                ></v-textarea>
              </v-flex>
              <v-flex>
                <v-textarea rows="1"
                  v-if="consText.length"
                  v-for="con in consText"
                  v-model="con.text"
                  :key="con.id"
                  :label="conLabel"
                  auto-grow
                ></v-textarea>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            @click="editReviewDialog = false"
            color="error"
            flat
          >
            {{ $t('review.reviewEditContainer.cancel') }}
          </v-btn>
          <div class="text-xs-center">
            <v-dialog
              v-model="confirmationDialog"
              width="500"
            >
              <template v-slot:activator="{ on }">
                <v-btn
                  v-on="on"
                  color="success"
                  flat
                  dark
                >
                  {{ $t('review.reviewEditContainer.update') }}
                </v-btn>
              </template>
              <v-card>
                <v-card-title
                  class="headline grey lighten-2"
                  primary-title
                >
                  {{ $t('review.reviewEditContainer.confirmChoice') }}
                </v-card-title>
                <v-card-text>
                  {{ $t('review.reviewEditContainer.confirmText') }}
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn
                    @click="confirmationDialog = false"
                    color="error"
                    flat
                  >
                    {{ $t('review.reviewEditContainer.cancel') }}
                  </v-btn>
                  <v-btn
                    @click="updateReviewInformation"
                    color="success"
                    flat
                  >
                    {{ $t('review.reviewEditContainer.update') }}
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </div>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>



// WEBPACK FOOTER //
// src/components/review/ReviewEditContainer.vue